export enum TypePermission {
  null,
  read,
  write
}

export enum Scope {
  public,
  protected,
  private
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/context/shared/context.enum.ts